import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const reviews = [{
  id: 1,
  name: 'Sarah Jenkins',
  location: 'USA',
  rating: 5,
  text: 'The Everest Base Camp trek was the most incredible experience of my life. The guides were professional, knowledgeable, and so supportive.',
  date: 'October 2023'
}, {
  id: 2,
  name: 'Mark & Lisa',
  location: 'Australia',
  rating: 5,
  text: 'Himalayan Trekking organized a perfect custom itinerary for our honeymoon in Bhutan. Every detail was taken care of. Highly recommended!',
  date: 'November 2023'
}, {
  id: 3,
  name: 'David Chen',
  location: 'Singapore',
  rating: 5,
  text: "I've done three treks with them now. Their commitment to safety and local culture is unmatched. Can't wait for the next adventure.",
  date: 'September 2023'
}];
export function ReviewsSection() {
  return <section className="py-20 bg-blue-50/50" data-id="element-292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <SectionHeading title="Traveler Stories" subtitle="Don't just take our word for it. Hear from our happy trekkers." data-id="element-294" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-295">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-296">
              <Quote className="absolute top-6 right-6 text-blue-100" size={48} data-id="element-297" />

              <div className="flex gap-1 mb-4" data-id="element-298">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-[#FFD700] text-[#FFD700]" data-id="element-299" />)}
              </div>

              <p className="text-gray-600 mb-6 italic relative z-10" data-id="element-300">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-301">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0066FF] to-[#06B6D4] flex items-center justify-center text-white font-bold" data-id="element-302">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-303">
                  <h4 className="font-bold text-gray-900 text-sm" data-id="element-304">
                    {review.name}
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-305">{review.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 flex justify-center items-center gap-2" data-id="element-306">
          <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google" className="h-6" data-id="element-307" />
          <div className="flex gap-1" data-id="element-308">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#FFD700] text-[#FFD700]" data-id="element-309" />)}
          </div>
          <span className="text-sm text-gray-600 font-medium" data-id="element-310">
            4.9/5 based on 250+ reviews
          </span>
        </div>
      </div>
    </section>;
}